export default __webpack_public_path__ + "static/media/1516 knife block B side.d960bf94.png";